/** Hash fragment prefix, e.g. `#badgeTemplateId=6aa92ce4bdbe0e473c40cd43` */
export const MEMBER_BADGE_HASH_PREFIX = 'badgeTemplateId='

export const buildMemberBadgeHash = (badgeTemplateId: string | null | undefined): string | null => {
  const trimmedTemplateId = badgeTemplateId?.trim()
  if (!trimmedTemplateId) {
    return null
  }

  return `${MEMBER_BADGE_HASH_PREFIX}${trimmedTemplateId}`
}

export const readMemberBadgeTemplateIdFromHash = (hash: string | null | undefined): string | null => {
  const rawHash = (hash ?? '').replace(/^#/, '').trim()
  if (!rawHash.startsWith(MEMBER_BADGE_HASH_PREFIX)) {
    return null
  }

  const templateId = rawHash.slice(MEMBER_BADGE_HASH_PREFIX.length).trim()
  return templateId || null
}

export const isMemberBadgeHash = (hash: string | null | undefined): boolean => readMemberBadgeTemplateIdFromHash(hash) !== null
